module.exports = __webpack_public_path__ + "static/img/step-01.727cffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onedriveBuiness/step-01.png
// module id = Kc8r
// module chunks = 2